import {selectTransaction, aUpdateTransaction, TransactionEntityActionTypes} from './transaction'
import {selectTransactionById} from '../features/transactions/store'

const dataCompositionMiddleware = store => next => action => {
  const res = next(action)

  if (typeof action !== 'function' && typeof action.type === 'string') {
    const {type, payload} = action

    switch (type) {
      case TransactionEntityActionTypes.PENDING:
        {
          const {transactionId} = payload?.fetchParams || {}
          if (typeof transactionId !== 'undefined') {
            const currentTransactionEntity = selectTransaction(store.getState())
            const partialTransaction = selectTransactionById(store.getState(), transactionId)

            if (partialTransaction && currentTransactionEntity?.id !== transactionId) {
              store.dispatch(aUpdateTransaction(partialTransaction, false))
            }
          }
        }
        break
      case TransactionEntityActionTypes.SUCCESS: {
        // do nothing
        break
      }

      default:
      // do nothing
    }
  }
  return res
}

export default dataCompositionMiddleware
